module.exports = __webpack_public_path__ + "img/prop-bird.49544c1e.webp";